import { render, staticRenderFns } from "./discountEdit.vue?vue&type=template&id=6daf08e0&scoped=true&lang=html&"
import script from "./discountEdit.vue?vue&type=script&lang=js&"
export * from "./discountEdit.vue?vue&type=script&lang=js&"
import style0 from "./discountEdit.vue?vue&type=style&index=0&id=6daf08e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6daf08e0",
  null
  
)

export default component.exports